var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedStarPnc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2789 1.41909C10.3727 1.2413 10.6273 1.2413 10.7211 1.41908L13.4991 6.68439C13.5353 6.75295 13.6012 6.80085 13.6776 6.81407L19.5437 7.82904C19.7417 7.86332 19.8204 8.10547 19.6803 8.24962L15.5312 12.5187C15.4771 12.5743 15.452 12.6518 15.463 12.7286L16.3104 18.6212C16.339 18.8201 16.133 18.9698 15.9526 18.8811L10.6103 16.2542C10.5407 16.22 10.4593 16.22 10.3897 16.2542L5.04736 18.8811C4.86698 18.9698 4.66098 18.8201 4.6896 18.6212L5.53701 12.7286C5.54804 12.6518 5.52286 12.5743 5.46883 12.5187L1.31968 8.24962C1.17958 8.10548 1.25826 7.86332 1.45634 7.82904L7.32239 6.81407C7.39877 6.80085 7.46471 6.75295 7.50088 6.68439L10.2789 1.41909Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedStarPnc);
export default __webpack_public_path__ + "static/media/feedStarPnc.50892b9d481c5874d50d5f2fc718ac33.svg";
export { ForwardRef as ReactComponent };